export const enum PermissionTypes {
    Brand = 1,
    Market = 2,
}
